export default {
  text: '#868786',
  primary: '#43aaab',
  secondary: '#CCF2F4',
  background: '#fdfdfd',
  backgroundSecondary: '#F4F9F9',
  light: '#fdfdfd',
  dark: '#484848'
}
